import { MultiValue, SingleValue } from "react-select";
import { SelectOptionTree } from "src/components/CategorySelectTree";

/**
 * Проверяет, является ли значение массивом (MultiValue)
 * @param value Значение для проверки
 * @returns true, если значение является массивом (MultiValue)
 */
export function isMultiValue(
  value?: MultiValue<SelectOptionTree> | SingleValue<SelectOptionTree>,
): value is MultiValue<SelectOptionTree> {
  return Array.isArray(value);
}
